<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import modalAddTermsToAttribute from "../../../components/modals/merchandise/modalAddTermsToAttribute.vue";
    import modalLinkTerm from "../../../components/modals/merchandise/modalLinkTerm.vue";
    import modalEditTerm from "../../../components/modals/merchandise/modalEditTerm.vue";
    import Swal from "sweetalert2";
    import Merchandising from "../../../services/Merchandising";

    export default {
        components: {
          Layout,
          PageHeader,
          modalAddTermsToAttribute,
          modalEditTerm,
          modalLinkTerm,
        },
        page: {
            title: "Manage Attribute Terms",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
         data() {
            return {
                isAuthorized: false,
                error: null,
                filterData: false,
                tableData: [],
                title: "Manage Attributes Terms",
                items: [
                    {
                        text: "Attributes",

                    },
                    {
                        text: "Manage Attribute Terms",
                        active: true,
                    },
                ],

                companyData: [],
                productCategories:[],
                id:'', // term_id
                termName:'',
                description:'',
                order:'',
                isBusy: false,
                totalRows: 0,
                attributeCategories:[],
                filteredProducts:[],
                modalProducts:[],
                attributeName:'',
                currentPage: 1,
                attr_id:this.$route.params.id,
                modalAttributeId:'',
                perPage: 10,
                pageOptions: [10, 25, 50, 100],
                filter: null,
                filterOn: [],
                sortBy: "order",
                sortDesc: false,
                fields: [
                    {
                      key: "name",
                      label: "Term Name",
                      sortable: true,
                    },
                    {
                        key: "description",
                        label: "Description",
                        sortable: true,
                    },

                    {
                        key: "order",
                        label: "Order",
                        sortable: true,
                    },
                    "action"
                ],
            };
        },

        methods: {
            openModalAddTermsToAttribute(id){
               this.modalAttributeId = id;
                this.$bvModal.show("add_terms_to_attribute");
            },
            openModalLinkTerm(term_id,name,products){
                this.id = term_id;
                this.termName = name
                this.modalProducts = products;
                this.$bvModal.show("link_term");
            },
            openModalUpdateTerm(term_id,attribute_id,name,description,order){
              this.modalAttributeId = attribute_id;
              this.id = term_id
              this.termName = name
              this.description = description
              this.order = order
              this.$bvModal.show("update_term");
            },
          decodeHtmlEntities(str) {
            const txt = document.createElement("textarea");
            txt.innerHTML = str;
            return txt.value;
          },

          async getTerms(){
                try {
                    this.filterData = true;
                    this.toggleBusy();

                    const response = await Merchandising.getTerms(this.attr_id)
                    this.tableData = response.data.data
                    this.totalRows = this.tableData.length


                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.tableData = []
                    this.totalRows = 0;
                } finally {
                    this.toggleBusy();
                }
            },

          async getAttributeByID(){
                try {
                    const response = await Merchandising.getAttributeById(this.attr_id)
                    this.attributeCategories = response.data.data[0].categories
                    this.attributeName = response.data.data[0].name
                    await  this.getProducts();

                } catch (error) {
                    this.error = error.response.data.error ? error.response.data.error : "";

                }
            },
          async getProducts(){
            try {
              const categoryIds = this.attributeCategories.map(category => category.category_id);
              const body = {
                category_ids: categoryIds,
              }
              // const response = await Merchandising.getProductsByCategoryAttributes(body);
              const response = await Merchandising.getProductsByCategoryAttributesMerch(body);
              this.filteredProducts = response.data.data;

            }catch (error){
              console.error(error);
            }
          },


          async removeTerm(term_id) {
            Swal.fire({
              title: "Remove Term?",
              text: "This term will be deleted and all linked products will be unlinked from this term!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: "Delete!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {

                        const response = await Merchandising.removeTerm(term_id);
                        if (response.data.data === true) {
                          Swal.fire("Success!", "Term is successfully deleted !", "success");
                          await  this.getTerms();
                        } else {
                            let errorMessage = response.error ? response.error : 'Failed';
                            if (typeof errorMessage === 'object') {
                                errorMessage = errorMessage[0];
                            }
                            Swal.fire("Fail!", errorMessage, "warning");
                        }
                    } catch (error) {
                        let errorMessage = error.response && error.response.data && error.response.data.error
                            ? error.response.data.error
                            : "An error occurred while deleting Term!";
                        if (typeof errorMessage === 'object') {
                          errorMessage = errorMessage[0];
                        }
                        Swal.fire("Error", errorMessage, "error");
                    }
                }
            });
          },

        },
        mounted() {
            this.getTerms();
            this.getAttributeByID();
        },
        middleware: "authentication",
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <div class="row">
            <div class="col-12">

                <div class="card">
                    <div class="card-body">

                            <div>
                                <a href="javascript:void(0);" @click="openModalAddTermsToAttribute(attr_id)" class="btn btn-success waves-effect waves-light me-3">
                                    <i class="mdi mdi-plus me-2"></i>
                                    Add New Term
                                </a>
                            </div>
                        <div class="row mt-2">
                            <div class="col d-flex gap-3  align-items-center" >
                              <h5 class="m-0">Attribute: {{attributeName}}</h5>
                              <h5 class="m-0">Total Terms: {{totalRows}}</h5>
                            </div>
                        </div>


                        <div class="row mt-4" v-show="filterData">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                                >
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="form-control form-control-sm ms-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0" v-show="filterData">
                            <b-table
                                :items="tableData"
                                :busy="isBusy"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                show-empty
                                empty-text="No Data Found"
                            >

                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>

                              <template  v-slot:cell(name)="data">
                                <span>{{ decodeHtmlEntities(data.item.name) }}</span>
                              </template>
                                <template  v-slot:cell(description)="data">
                                  <span>{{ data.item.description ? data.item.description : 'N/A' }}</span>
                                </template>

                                <template v-slot:cell(action)="data">
                                    <ul class="list-inline mb-0 d-flex">
                                        <li class="list-inline-item">
                                            <a href="javascript:void(0)" @click="openModalLinkTerm(data.item.term_id,data.item.name,filteredProducts)" title="Link Term to Product">
                                              <i class="uil uil-link font-size-18"></i>
                                            </a>
                                        </li>

                                        <li class="list-inline-item">
                                          <a  href="javascript:void(0);" class="px-2 text-black" title="Edit Term" @click="
                                          openModalUpdateTerm(data.item.term_id,attr_id,data.item.name,data.item.description,data.item.order)
                                          ">
                                            <i class="fas fa-pen font-size-14 text-primary" ></i>
                                          </a>
                                          <a  href="javascript:void(0);" class="px-2 text-black" title="Remove Term" @click="removeTerm(data.item.term_id)">
                                            <i class="uil uil-trash-alt font-size-18 text-danger" ></i>
                                          </a>
                                      </li>
                                    </ul>
                                </template>
                            </b-table>
                        </div>
                        <div class="row" v-show="filterData">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="totalRows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modalAddTermsToAttribute @onRefresh="getTerms" :id="this.modalAttributeId"></modalAddTermsToAttribute>
        <modalEditTerm @onRefresh="getTerms" :id="this.id" :attr_id="this.modalAttributeId" :name="this.termName" :description="this.description" :order="this.order"></modalEditTerm>
        <modalLinkTerm @onRefresh="getTerms" :id="this.id" :name="this.termName" :products="modalProducts"></modalLinkTerm>
    </Layout>
</template>
